import { CallState, Dataset, LoadingState, WorkflowV1Read } from '@ca/core/models';

export const machineLearningFeatureKey = 'machine-learning';

export interface MachineLearningState {
    loading: boolean;
    trainingWorkflows: WorkflowV1Read[];
    segmentationWorkflows: WorkflowV1Read[];
    datasets: Dataset[];
    totalCount: number;
    error?: string;
    loadTrainingWorkflowsError: boolean;
    loadTrainingWorkflowsSuccess: boolean;
    loadSegmentationWorkflowsError: boolean;
    loadSegmentationWorkflowsSuccess: boolean;
    datasetCallState: CallState;
    numberOfAllDatasetsCallState: CallState;
    numberOfAllDatasets: number;
}

export const initialMachineLearningState: MachineLearningState = {
    loading: false,
    trainingWorkflows: [],
    segmentationWorkflows: [],
    datasets: [],
    totalCount: 0,
    error: undefined,
    loadTrainingWorkflowsError: false,
    loadTrainingWorkflowsSuccess: false,
    loadSegmentationWorkflowsError: false,
    loadSegmentationWorkflowsSuccess: false,
    datasetCallState: LoadingState.INIT,
    numberOfAllDatasetsCallState: LoadingState.INIT,
    numberOfAllDatasets: 0,
};
